// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SpecsSection-module__wrapper","subWrapper":"SpecsSection-module__subWrapper"};